import { render, staticRenderFns } from "./request-data-candidate.vue?vue&type=template&id=12849cc2&scoped=true&"
import script from "./request-data-candidate.vue?vue&type=script&lang=js&"
export * from "./request-data-candidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12849cc2",
  null
  
)

export default component.exports